<template>
  <div class="antecedent-container">
    <h3 class="antecedent-title">{{ title }}</h3>
    <ul class="antecedent-list">
      <li
        v-for="antecedent of antecedents"
        :key="antecedent.value"
        class="antecedent-item"
        :style="{ backgroundColor: color }"
      >
        <span>✓</span>
        {{ antecedent.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ListAntecedents',
  props: {
    title: {
      type: String,
      require: true,
    },
    antecedents: {
      type: Array,
      require: true,
    },
    color: {
      type: String,
      default: '#B8B5B2',
    },
  },
};
</script>

<style scope lang="scss">
.antecedent {
  &-container {
    margin-bottom: 1rem;
  }

  &-title {
    font-size: 1rem;
    color: var(--color-main);
  }

  &-list {
    margin: 0;
    padding-left: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    list-style-type: none;
  }

  &-item {
    padding: 1rem 0.7rem;
    border-radius: 10px;
    color: #fff;

    span {
      margin: 1rem;
    }
  }
}
</style>
